(function () {
  var STORAGE_KEY = 'satinco_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function isFavorited(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleFavorite(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? ' (' + count + ')' : '';
    });
  }

  function syncButtonState(btn) {
    var handle = btn.getAttribute('data-handle');
    var favorited = isFavorited(handle);
    btn.classList.toggle('is-favorited', favorited);
    btn.setAttribute('aria-pressed', favorited ? 'true' : 'false');
    var label = btn.querySelector('.wishlist-btn-label');
    if (label) label.textContent = favorited ? 'Saved to Favorites' : 'Save to Favorites';
  }

  function initToggleButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      syncButtonState(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-handle');
        toggleFavorite(handle);
        syncButtonState(btn);
        updateCountBadges();
        if (document.body.dataset.wishlistPage === 'true') {
          renderFavoritesPage();
        }
      });
    });
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function heartSvg() {
    return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7.5-4.6-10-9.3C.5 8.2 2.3 4.5 6 4c2.1-.3 4 .9 6 3 2-2.1 3.9-3.3 6-3 3.7.5 5.5 4.2 4 7.7C19.5 16.4 12 21 12 21z"/></svg>';
  }

  function renderFavoritesPage() {
    var container = document.getElementById('FavoritesGrid');
    var emptyState = document.getElementById('FavoritesEmpty');
    if (!container) return;

    var handles = getWishlist();
    if (handles.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.style.display = '';
      return;
    }
    if (emptyState) emptyState.style.display = 'none';

    container.innerHTML = '<p class="favorites-loading">Loading your favorites...</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return (r.ok ? r.json() : null); })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var html = '';
      products.forEach(function (product) {
        if (!product) return;
        var image = product.featured_image || (product.images && product.images[0]);
        html +=
          '<div class="ext-card">' +
          '<a class="ext-card-overlay-link" href="/products/' + product.handle + '" aria-label="' + escapeHtml(product.title) + '"></a>' +
          '<div class="ext-media">' +
          (image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
          (!product.available ? '<span class="tag">Sold Out</span>' : '') +
          '</div>' +
          '<div class="ext-info">' +
          '<div><h4>' + escapeHtml(product.title) + '</h4><div class="cat">' + escapeHtml(product.type || '') + '</div></div>' +
          '<div class="price">' + (product.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + '</div>' +
          '</div>' +
          '<button type="button" class="wishlist-btn is-favorited" data-wishlist-toggle data-handle="' + product.handle + '" aria-label="Remove from favorites">' + heartSvg() + '</button>' +
          '</div>';
      });
      container.innerHTML = html;
      initToggleButtons();
      if (container.innerHTML === '') {
        if (emptyState) emptyState.style.display = '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initToggleButtons();
    updateCountBadges();
    if (document.body.dataset.wishlistPage === 'true') {
      renderFavoritesPage();
    }
  });
})();
